module.exports = __webpack_public_path__ + "static/media/hcp-logo.49cc3a44.svg";